import React from "react";
import { useSelector } from "react-redux";

const ProgressBar = () => {
  const progress = useSelector((state) => state.progress.progress);

  return (
    <div className= "progress-bar" style={{ }}>
      <div
        data-testid="progress-fill"
        style={{
          width: `${progress}%`,
          height: "10px",
          backgroundColor: "#045326",
          transition: "width 0.3s ease-in-out",
          borderRadius: "20px"
        }}
      />
    </div>
  );
};

export default ProgressBar;
